import validate from 'mixins/validate';

export default {
  props: {
    name: String,
    inputId: String,
    label: String,
    type: {
      type: String,
      default: 'text',
    },
    modifier: {
      type: String,
      default: 'default',
    },
    autocorrect: Boolean,
    autocapitalize: Boolean,
    initialValueGetter: Function,
    placeholder: String,
    error: String,
    required: Boolean,
    validateMethod: Function,
    instantInvalidation: false, // Sets invalid as we change the value not on blur
  },
  mixins: [validate],
  data() {
    const data = {
      isValid: true,
      isActive: false,
      showErrorMessage: false,
      dirty: false,
    };

    if (
      this.initialValueGetter &&
      this.initialValueGetter.bind !== 'undefined'
    ) {
      data.inputValue = this.initialValueGetter(this.name);
    } else {
      data.inputValue = '';
    }

    return data;
  },
  watch: {
    inputValue() {
      this.$emit('change', {
        value: this.inputValue,
        name: this.name,
      });

      this.validateOnChange();
    },
  },
  mounted() {
    this.$emit('change', {
      value: this.inputValue,
      name: this.name,
    });

    if (this.inputValue) this.setActive();
  },
  methods: {
    validateOnChange() {
      if (this.validateMethod) {
        const response = this.validateMethod({
          value: this.inputValue,
          name: this.name,
          required: this.required,
        });

        if (response.valid) {
          this.isValid = true;
        } else if (this.instantInvalidation) {
          this.isValid = false;
        }
      } else if (this.required && this.inputValue) {
        this.isValid = true;
      }
    },
    validateInput() {
      if (this.validateMethod) {
        const response = this.validateMethod({
          value: this.inputValue,
          name: this.name,
          required: this.required,
        });
        this.isValid = response.valid;
      } else if (this.required && !this.inputValue) {
        this.isValid = false;
      } else {
        this.isValid = true;
      }
      return this.isValid;
    },
    setActive() {
      this.isActive = true;
    },
    unsetActive() {
      if (!this.dirty) this.dirty = true;

      this.validateInput();

      if (!this.isValid) {
        window.dataLayer.push({
          event: 'error_captured',
          error_message: this.error,
        });
      }

      if (!this.inputValue) this.isActive = false;
    },
    refresh() {
      setTimeout(() => {
        this.inputValue = this.$refs.input.value;
        if (this.inputValue) this.setActive();
      }, 0);
    },
  },
  template: `
  <div class="text-input-alt" :class="['text-input-alt--'+modifier, (!isValid)?'form-row__error': '' ]">
    <div class="text-input-alt__wrapper" :class="{ 'has-error' : dirty && !isValid }">
      <input
        ref="input"
        class="text-input-alt__el p2"
        :type="type"
        :name="name"
        :id="inputId"
        :autocorrect="autocorrect"
        :autocapitalize="autocapitalize"
        placeholder=""
        v-model="inputValue"
        v-on:focus="setActive"
        v-on:blur="unsetActive" />

        <label :for="inputId" class="text-input-alt__label" :class="[ isActive ? 'is-active' : '', dirty && !isValid && isActive ? 'red' : '' ]" v-text="label"></label>
    </div>
    <transition name="fade">
      <p v-if="(dirty && !isValid) || (instantInvalidation && !isValid)" class="f2 form-row__error__text-error red">{{error}}</p>
    </transition>
  </div>`,
};
